import React from "react"
import styled from "@emotion/styled"
import Time from "../../../icons/svg/Time"
import { breakpoints, color } from "../../../utils/style"
import PropTypes from "prop-types"
import Img from "gatsby-image"

const BlockWrapper = styled('div')`
  display: flex;
  flex-flow: row wrap;
  margin: 60px 0;
  h2 {
    font-size: 1.8rem;
  }
  .col-left {
    flex-basis: 43%;
    background: ${color.transparentDarkRed6};
    border: 4px solid ${color.red};
    box-shadow: 0 8px 24px rgba(104, 0, 0, 0.3);
    backdrop-filter: blur(12px);
    border-radius: 8px;
    padding: 20px;
  }
  .description {
    p {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 20px;
      font-weight: 400;
    }
    .bold {
      font-weight: 600;
    }
  }
  .col-right {
    flex-basis: 53%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .item {
      flex-basis: 40%;
    }
    .gatsby-image-wrapper {
      width: 100%;
      max-width: 198px;
      display: block;
      margin: 0 auto 15px;
    }
    .button {
      width: 100%;
    }
  }
  @media(max-width: ${breakpoints.md}) {
    .col-left {
      flex-basis: 100%;
    }
    .col-right {
      flex-basis: 100%;
      margin-top: 20px;
    }
  }
  @media(max-width: ${breakpoints.sm}) {
    .col-right {
      flex-flow: row wrap;
      .item {
        flex-basis: 100%;
      }
    }
  }
`

const EntranceLinksApp = ({ gallery }) => {
  return (
    <BlockWrapper>
      <div className="col-left">
        <h2 className="h1 with-icon rich-design a-center">
          <Time/>
          <span>รหัสเข้าใช้งาน ROYAL1688</span>
        </h2>
        <div className="description">
          <p>เลือก 1 ยูสเซอร์เนม จากด้านล่างนี้</p>
          <p className="bold">amacp001, amacp002, amacp003, amacp004, amacp005</p>
          <p>และใช้รหัสผ่านนี้: <span className="bold">aa1234</span></p>
        </div>
      </div>
      <div className="col-right">
        {gallery?.map((item, index) => {
          const localFile = item?.localFile || {}
          return (
            <div className="item" key={index + Math.random() * 100}>
              <div>
                {localFile?.childImageSharp &&
                localFile?.childImageSharp?.fluid && (
                  <Img
                    fluid={localFile.childImageSharp.fluid}
                    alt={item.alt_text ? item.alt_text : 'royal-1688.net'}
                    fadeIn={false}
                    loading="eager"
                  />
                )}
              </div>
              <div>
                {item?.acf?.slide_title && item?.acf?.slide_url && (
                  <a
                    href={item.acf.slide_url}
                    className="button transparent-button-gold"
                  >
                    {item.acf.slide_title}
                  </a>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </BlockWrapper>
  )
}

EntranceLinksApp.propTypes = {
  gallery: PropTypes.arrayOf(
    PropTypes.shape({
      acf: PropTypes.shape({
        slide_description: PropTypes.string,
        slide_title: PropTypes.string,
        slide_url: PropTypes.string,
      }),
      alt_text: PropTypes.string,
      path: PropTypes.string,
      title: PropTypes.string,
    })
  ),
}

EntranceLinksApp.defaultProps = {
  gallery: [],
}

export default EntranceLinksApp